import {Controller} from "stimulus";

/**
 * InputDisableController handles disabling annotated elements when instructed via events.
 *
 * Apply `data-input-disable-target="disableable"` to elements you wish to disable.
 * Use `data-action="input-disable#disable" to disable the opted-in elements.
 * This works well for submit buttons paired with Turbo - disable the submit button when inputs change and re-enable via turbo by re-rendering.
 */

export default class InputDisableController extends Controller {
  static targets = ["disableable"];

  declare disableableTargets: HTMLElement[];

  disable() {
    this.disableableTargets.forEach((element) => element.setAttribute("disabled", "disabled"));
  }
}
